import { merge } from 'lodash'

import ChannelsEnum from './modules/channels/channels'
import FiltersEnum from './modules/filters/filters'
import FiltersOperatorsEnum from './modules/filters/operators/operators'
import GrowthExperimentEnum from './modules/growthExperiment'
import StatusesEnum from './modules/statuses/statuses'
import StatusDetailsEnum from './modules/statusDetails/statusDetails'
import UserEnum from './modules/user'
import AttachmentsEnum from './modules/attachments/attachments'
import PaymentMethodEnum from './modules/paymentMethod'
import ShippingMethodEnum from './modules/shippingMethod'
import OrderTypeEnum from './modules/orderType'
import PlatformSourcesEnum from './modules/platformSources/platformSources'
import { WroSlaStatusEnum, WroBoxSlaEnum, WroStatusesEnum, WroSendOptionsEnum, WroPackageTypesEnum, WroBoxConfigurationEnum, WroColumnNamesEnum, WroFilterEnum, WroBoxStatusesEnum } from './modules/receiving'
import PackagingType from '@/enums/modules/creatingWarehouseReceivingOrder/packagingType'
import OrderDetailsLogsEnum from '@/enums/modules/orderDetails/logs'
import ShippingOptionsEnum from '@/enums/modules/shippingOptions'
import ReturnReasonsEnum from '@/enums/modules/returnReasons'
import { PackageMaterialTypeEnum } from '@/enums/modules/orderDetails/packageMaterialType'
import { ReturnsFiltersEnum } from '@/enums/modules/returns'
import { SlaStatusIdsEnum, SlaStatusEnum } from '@/enums/modules/orders/slaStatus'
import { OrderDetailsOrderTypeEnum } from '@/enums/modules/orderDetails/orderType'
import { CarrierNameEnum } from '@/enums/modules/labeling/carriers'

import ChannelsMessages from './modules/channels/channels.messages'
import FiltersMessages from './modules/filters/filters.messages'
import FiltersOperatorsMessages from './modules/filters/operators/operators.messages'
import StatusesMessages from './modules/statuses/statuses.messages'
import StatusDetailsMessages from './modules/statusDetails/statusDetails.messages'
import AttachmentsMessages from './modules/attachments/attachments.messages'
import ECommercePlatformMessages from './modules/setup/eCommercePlatforms.messages'
import WhenToStartShippingOptionsMessages from './modules/setup/whenToStartShippingOptions.messages'
import ECommerceStageMessages from './modules/setup/eCommerceStage.messages'
import PlatformSourcesMessages from './modules/platformSources/platformSources.messages'
import { WroSlaStatusMessages, WroBoxSlaMessages, WroStatusesMessages, WroSendOptionsMessages, WroPackageTypesMessages, WroBoxConfigurationMessages, WroColumnNamesMessages, WroFilterMessages, WroBoxStatusesMessages } from './modules/receiving/index.messages'
import PackagingTypeMessages from '@/enums/modules/creatingWarehouseReceivingOrder/packagingType.messages'
import OrderDetailsStatusMessages from '@/enums/modules/orderDetails/statuses.messages'
import OrderDetailsLogsMessages from '@/enums/modules/orderDetails/logs.messages'
import OrderDetailsTimelineMessages from '@/enums/modules/orderDetails/timeline.messages'
import { ShippingSpeedMessages, ShipOptionsMessages, CarrierSpecificMessages } from '@/enums/modules/orderDetails/shipOptions.messages'
import ShippingOptionsMessages from '@/enums/modules/shippingOptions/index.messages.js'
import ReturnReasonsMessages from '@/enums/modules/returnReasons/index.messages.js'
import AdditionalPricingChargeMessages from '@/enums/modules/orderDetails/additionalPricingCharges.messages'
import { PackageMaterialTypeMessages } from '@/enums/modules/orderDetails/packageMaterialType.messages.js'
import OrderStatusDetailsMessages from '@/enums/modules/orderDetails/statusDetails.messages'
import { ReturnsMessages } from '@/enums/modules/returns/index.messages'
import { InventoryMessages } from '@/enums/modules/inventory/index.messages'
import { SlaStatusMessages } from '@/enums/modules/orders/slaStatus.messages'
import { OrderDetailsOrderTypeMessages } from '@/enums/modules/orderDetails/orderType.messages'
import KittingMessages from '@/enums/modules/workOrders/kitting/index.messages'

export const messages = merge(
  ChannelsMessages,
  FiltersMessages,
  FiltersOperatorsMessages,
  StatusesMessages,
  StatusDetailsMessages,
  AttachmentsMessages,
  ECommercePlatformMessages,
  WhenToStartShippingOptionsMessages,
  ECommerceStageMessages,
  PlatformSourcesMessages,
  WroStatusesMessages,
  WroBoxStatusesMessages,
  WroSendOptionsMessages,
  WroPackageTypesMessages,
  WroBoxConfigurationMessages,
  WroColumnNamesMessages,
  WroFilterMessages,
  PackagingTypeMessages,
  WroBoxSlaMessages,
  WroSlaStatusMessages,
  OrderDetailsStatusMessages,
  OrderDetailsLogsMessages,
  OrderStatusDetailsMessages,
  OrderDetailsTimelineMessages,
  ShippingSpeedMessages,
  ShipOptionsMessages,
  CarrierSpecificMessages,
  ShippingOptionsMessages,
  AdditionalPricingChargeMessages,
  ReturnReasonsMessages,
  PackageMaterialTypeMessages,
  ReturnsMessages,
  InventoryMessages,
  SlaStatusMessages,
  OrderDetailsOrderTypeMessages,
  KittingMessages
)

export {
  ChannelsEnum,
  FiltersEnum,
  FiltersOperatorsEnum,
  GrowthExperimentEnum,
  StatusesEnum,
  StatusDetailsEnum,
  UserEnum,
  AttachmentsEnum,
  PaymentMethodEnum,
  ShippingMethodEnum,
  OrderTypeEnum,
  PlatformSourcesEnum,
  WroStatusesEnum,
  WroBoxStatusesEnum,
  WroSendOptionsEnum,
  WroPackageTypesEnum,
  WroBoxConfigurationEnum,
  WroColumnNamesEnum,
  WroFilterEnum,
  PackagingType,
  WroBoxSlaEnum,
  WroSlaStatusEnum,
  OrderDetailsLogsEnum,
  ShippingOptionsEnum,
  ReturnReasonsEnum,
  PackageMaterialTypeEnum,
  ReturnsFiltersEnum,
  SlaStatusIdsEnum,
  SlaStatusEnum,
  OrderDetailsOrderTypeEnum,
  CarrierNameEnum
}
